<template>
  <div>
        <div
        v-if="item.type == 'task' && item.taskType > 0"
        class="task task--item"
        >
      
        <div  
        @click="editField"
        @mouseover="$emit('disableDrag2', true); disableItemDrag2 = true"
        @mouseout="$emit('disableDrag2', false); disableItemDrag2 = false"
        >
            <editor 
                v-if="!item.editing"
                :style="{'margin-top': checkVotingState(item) ? '30px' : ''}"
                class="task--text"
                :isEditing="item.editing"
                :readOnly="true"
                :imagesAllowed="false"
                v-model="item.content"
            />
        </div>
        <editor 
            v-if="(item.editing && (!item.half || isLeftHalf(topicIndex, itemIndex)))"
            :ref="`editor-${topicIndex}-${itemIndex}`"
            :class="['editor--content', (item.editing ? 'editing' : '')]"
            :isEditing="item.editing"
            :readOnly="false"
            :imagesAllowed="false"
            v-model="item.content"
            v-click-outside="closeEditor"
        />
        <div v-if="item.taskType == 1">
            <div 
            class="add--task--answer"
            @click="addTaskAnswer(topicIndex, itemIndex)"
            >
            <img src="@/assets/images/icons/plus-gray.svg">
            {{ toLocal('hierarchy.add') }}
            </div>
            <div class="task--colors">
            <div class="task--color--correct" />
            {{ toLocal('training_edit.correct') }}
            <div class="task--color--incorrect" />
            {{ toLocal('training_edit.incorrect') }}
            </div>
            <div
            class="task--answers"
            >
            <draggable
                v-model="item.answers"
                animation="200"
                :options="{disabled: disableItemDrag2, animation:200, group: 'description', ghostClass: 'ghost'}"
                class="list-group"
            >
                <transition-group type="transition" :name="'flip-list'">
                <div 
                    v-for="(answer, answerIndex) in item.answers"
                    :key="answer.text+'-'+answerIndex"
                    class="task--answer"
                >
                    <svg @click="deleteTaskAnswer(topicIndex, itemIndex, answerIndex)" class="stroke task--answer--remove" xmlns="http://www.w3.org/2000/svg" width="20.317" height="25.807" viewBox="0 0 20.317 25.807">
                    <g id="Group_308" data-name="Group 308" transform="translate(-7004.16 -1767.753)">
                        <path id="Rectangle_184" data-name="Rectangle 184" d="M0,0H14.988a0,0,0,0,1,0,0V13A6.028,6.028,0,0,1,8.96,19.023H6.028A6.028,6.028,0,0,1,0,13V0A0,0,0,0,1,0,0Z" transform="translate(7006.825 1773.636)" fill="none" stroke="#707070" stroke-miterlimit="10" stroke-width="1.8"/>
                        <path id="Path_550" data-name="Path 550" d="M7023.577,1775.469a1.48,1.48,0,0,1-1.476,1.476h-15.566a1.476,1.476,0,1,1,0-2.951H7022.1A1.474,1.474,0,0,1,7023.577,1775.469Z" transform="translate(0 -3.309)" fill="none" stroke="#707070" stroke-miterlimit="10" stroke-width="1.8"/>
                        <path id="Path_551" data-name="Path 551" d="M7027.308,1770.129a1.489,1.489,0,0,1-.106.555h-6.465a1.48,1.48,0,0,1-.107-.555,1.481,1.481,0,0,1,1.476-1.476h3.723A1.478,1.478,0,0,1,7027.308,1770.129Z" transform="translate(-9.649 0)" fill="none" stroke="#707070" stroke-miterlimit="10" stroke-width="1.8"/>
                        <g id="Group_290" data-name="Group 290" transform="translate(7010.68 1776.735)">
                        <line id="Line_35" data-name="Line 35" y2="11.889" transform="translate(7.278)" fill="none" stroke="#707070" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.8"/>
                        <line id="Line_36" data-name="Line 36" y2="11.889" transform="translate(3.639)" fill="none" stroke="#707070" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.8"/>
                        <line id="Line_37" data-name="Line 37" y2="11.889" fill="none" stroke="#707070" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.8"/>
                        </g>
                    </g>
                    </svg>
                    <div 
                    :class="['task--answer--letter', {'active': answer.correct}]"
                    @click="answerClick(answer)"
                    >
                    {{ String.fromCharCode(65 + answerIndex) }}
                    </div>
                    <div
                        class="task--answer--text"
                        v-if="currentlyEditingAnswer!=answerIndex"
                        @click="editTaskAnswer(answerIndex, -1)"
                        @mouseover="$emit('disableDrag2', true); disableItemDrag2 = true"
                        @mouseout="$emit('disableDrag2', false); disableItemDrag2 = false"
                        v-html="convertToHyperlinks(answer.text)"
                    >
                    </div>
                    <input
                    v-if="currentlyEditingAnswer == answerIndex"
                    :ref="`taskAnswer-${answerIndex}`"
                    v-click-outside="clickOutsideAnswerTitle"
                    class="training--content--topic--edit task--answer--text--edit"
                    type="text"
                    @mouseover="$emit('disableDrag2', true); disableItemDrag2 = true"
                    @mouseout="$emit('disableDrag2', false); disableItemDrag2 = false"
                    @blur="setTaskAnswer(topicIndex, itemIndex, answerIndex, -1, $event.srcElement.value)"
                    @keyup.enter="setTaskAnswer(topicIndex, itemIndex, answerIndex, -1, $event.srcElement.value)"
                    >
                </div>
                </transition-group>
            </draggable>
            </div>

        </div>
        <!-- <test-task
            :topic="trainingTopic"
            :item="item"
            :itemIndex="itemIndex"
            :topicIndex="topicIndex"
            :type="type"
        /> -->
        <div v-if="item.taskType == 2">
            <div class="task--colors">
            <div class="task--color--correct" />
            {{ toLocal('training_edit.correct') }}
            <div class="task--color--incorrect" />
            {{ toLocal('training_edit.incorrect') }}
            </div>
            <div class="task--images">
            <div 
                v-for="(answer, answerIndex) in item.answers"
                :key="getFileUrl(answer.image)"
                class="task--image"
            >
                <div 
                :class="['task--answer--letter', {'active': answer.correct}]"
                @click="answerClick(answer)"
                >
                {{ String.fromCharCode(65 + answerIndex) }}
                </div>
                <input 
                type="file" 
                :ref="`item-${topicIndex}-${itemIndex}`" 
                style="display:none"
                @change="onTrainingMediaChange($event,topicIndex, itemIndex, answerIndex)"
                >
                <!-- <ImageEditor
                    v-if="(answer.metadata ? answer.metadata.data : false)" 
                    :height="200"
                    :width="200"
                    :initial="getFileUrl(answer.image)"
                    :metadata="answer.metadata"
                    @disableDrag="$emit('disableDrag2', true); disableItemDrag2 = true"
                    @enableDrag="$emit('disableDrag2', false); disableItemDrag2 = false"
                    @saveMetadata="saveMetadata($event, item,answerIndex)"
                    @deleteImage="deleteTaskAnswer(topicIndex, itemIndex, answerIndex)"
                >
                <template v-slot:is-uploading>
                <div v-if="answer.uploading" :class="['uploading', (item.uploading ? 'active': '')]">
                    <div 
                    class="upload--progress"
                    :style="[{'width': `${$store.state.uploadedData / item.file_size * 100}%`}]" 
                    />
                </div>
                </template>
            </ImageEditor> -->
            <NewImageEditor 
                :readOnly="false"
                :item="answer"
                type="cover"
                :height="200"
                :isEditing="isEditing"
                :src="getFileUrl(answer.image)"
                @disableDrag="$emit('disableDrag2', true)"
                @enableDrag="$emit('disableDrag2', false)"
                @deleteImage="deleteTaskAnswer(topicIndex, itemIndex, answerIndex)"
            />

            </div>
            <div class="add--image task--image">

                <input 
                :ref="`itemFile-${item.answers.length}`" 
                accept=".jpeg,.jpg,.png"
                type="file"
                style="display: none;"
                @change="onTrainingMediaChange($event,topicIndex, itemIndex, item.answers.length)"
                >
                <div class="media--action">
                <img 
                    src="@/assets/images/icons/training-item-upload.svg"
                    @click="openImageSelectInput(item.answers.length)" 
                >
                </div>
                <div class="media--action">
                <img
                    src="@/assets/images/icons/training-item-gallery.svg"
                >
                </div>
            </div>
            </div>
        </div>
        <div v-if="item.taskType == 3">
            <div 
            class="add--task--answer"
            @click="addTaskAnswer(topicIndex, itemIndex)"
            >
            <img src="@/assets/images/icons/plus-gray.svg">
            {{ toLocal('hierarchy.add') }}
            </div>
            <div
            class="task--connects"
            @mouseover="$emit('disableDrag2', true); disableItemDrag2 = true"
            @mouseout="$emit('disableDrag2', false); disableItemDrag2 = false"
            >
            <draggable
                v-model="item.answers"
                animation="200"
                :options="{animation:200, group: 'description', ghostClass: 'ghost'}"
            >
                <transition-group type="transition" :name="'flip-list'">
                <div 
                    v-for="(answer, answerIndex) in item.answers"
                    :key="answer.part1+'-'+answerIndex"
                    class="task--connect"
                >
                    <div 
                        v-if="currentlyEditingAnswer!=answerIndex || partIndex !=0"
                        class="task--connect--part1"
                        @click="editTaskAnswer(answerIndex, 0)"
                    >   
                        <div class="text-wrapper">
                            <div>
                                {{ answer.part1 }}
                            </div>
                        </div>
                    </div>
                    <textarea
                        v-if="currentlyEditingAnswer==answerIndex && partIndex == 0"
                        :ref="`taskAnswer-${answerIndex}-0`"
                        v-click-outside="editField"
                        class="training--content--topic--edit task--connect--text--edit part--1"
                        type="text"
                        @keyup.enter="setTaskAnswer(topicIndex, itemIndex, answerIndex, 0, $event.srcElement.value)"
                    />
                    <div 
                        v-if="currentlyEditingAnswer!=answerIndex || partIndex != 1"
                        class="task--connect--part2"
                        @click="editTaskAnswer(answerIndex, 1)"
                    >
                        <div class="text-wrapper">
                            <div>
                                {{ answer.part2 }}
                            </div>
                            </div>
                        </div>
                        <textarea
                        v-if="currentlyEditingAnswer==answerIndex && partIndex == 1"
                        :ref="`taskAnswer-${answerIndex}-1`"
                        v-click-outside="editField"
                        class="training--content--topic--edit task--connect--text--edit part--2"
                        type="text"
                        @keyup.enter="setTaskAnswer(topicIndex, itemIndex, answerIndex, 1, $event.srcElement.value)"
                        />
                        <svg @click="deleteTaskConnect(item, topicIndex, itemIndex, answerIndex)" class="stroke" xmlns="http://www.w3.org/2000/svg" width="20.317" height="25.807" viewBox="0 0 20.317 25.807">
                            <g id="Group_308" data-name="Group 308" transform="translate(-7004.16 -1767.753)">
                                <path id="Rectangle_184" data-name="Rectangle 184" d="M0,0H14.988a0,0,0,0,1,0,0V13A6.028,6.028,0,0,1,8.96,19.023H6.028A6.028,6.028,0,0,1,0,13V0A0,0,0,0,1,0,0Z" transform="translate(7006.825 1773.636)" fill="none" stroke="#707070" stroke-miterlimit="10" stroke-width="1.8"/>
                                <path id="Path_550" data-name="Path 550" d="M7023.577,1775.469a1.48,1.48,0,0,1-1.476,1.476h-15.566a1.476,1.476,0,1,1,0-2.951H7022.1A1.474,1.474,0,0,1,7023.577,1775.469Z" transform="translate(0 -3.309)" fill="none" stroke="#707070" stroke-miterlimit="10" stroke-width="1.8"/>
                                <path id="Path_551" data-name="Path 551" d="M7027.308,1770.129a1.489,1.489,0,0,1-.106.555h-6.465a1.48,1.48,0,0,1-.107-.555,1.481,1.481,0,0,1,1.476-1.476h3.723A1.478,1.478,0,0,1,7027.308,1770.129Z" transform="translate(-9.649 0)" fill="none" stroke="#707070" stroke-miterlimit="10" stroke-width="1.8"/>
                                <g id="Group_290" data-name="Group 290" transform="translate(7010.68 1776.735)">
                                <line id="Line_35" data-name="Line 35" y2="11.889" transform="translate(7.278)" fill="none" stroke="#707070" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.8"/>
                                <line id="Line_36" data-name="Line 36" y2="11.889" transform="translate(3.639)" fill="none" stroke="#707070" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.8"/>
                                <line id="Line_37" data-name="Line 37" y2="11.889" fill="none" stroke="#707070" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.8"/>
                                </g>
                            </g>
                        </svg>
                    </div>
                </transition-group>
            </draggable>
            </div>
        </div>
        <div 
            class="task--comments" 
            @mouseover="$emit('disableDrag2', true); disableItemDrag2 = true"
            @mouseout="$emit('disableDrag2', false); disableItemDrag2 = false"
        >
            <div
                class="task--comments--tabs"
            >
                <div
                   v-for="(tab, tab_index) in tabs.filter(tab => item.voting ? tab.id != 1 : true)" 
                   :key="tab.id"
                   :class="['task--comments--tab', {'active': item.comment_tab == tab.id}]"
                   @click="setTaskCommentTab(topicIndex, itemIndex, tab.id)"
                >
                    {{ toLocal(tab.label) }}
                </div>
            </div>
            <div class="task--comments">
                <div class="input-wrapper" v-if="item.comment_tab !=2">
                    <div v-for="(input, inputIndex) in tabs[item.comment_tab].inputs" :key="inputIndex" v-show="item.comment_tab==tabs[item.comment_tab].id">
                        <input
                            v-if="editingComments.includes(inputIndex)"    
                            v-model="item[input.value]"
                            v-click-outside-2="clickOutsideComments"
                            :ref="'comment-1-'+inputIndex"
                            class="training--content--topic--edit task--comment--input"
                            type="text"
                            :placeholder="toLocal(input.placeholder)"
                        >
                        <div  
                            @click="editingComments.push(inputIndex); $nextTick(() => $refs['comment-1-'+inputIndex][0].focus())" 
                            v-else 
                            class="task--comment--input comment--text" 
                            v-html="convertToHyperlinks(item[input.value] && item[input.value].length > 0 ? item[input.value] : toLocal(input.placeholder))"
                        >
                        </div>
                        <button @click="editComment(input, inputIndex)">
                            <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">                        <rect x="0.5" y="0.5" width="20.0015" height="14.7511" rx="1.5" fill="#F4F4F4" stroke="#7D7D7D"/>                        <circle cx="5.25061" cy="5.25013" r="1.25013" fill="#F4F4F4" stroke="#7D7D7D"/>                        <path d="M11.867 6.49196C12.0669 6.25208 12.4353 6.25208 12.6352 6.49196L19.2508 14.4307C19.5222 14.7563 19.2906 15.2508 18.8667 15.2508H5.63553C5.21161 15.2508 4.98003 14.7563 5.25142 14.4307L11.867 6.49196Z" fill="#F4F4F4" stroke="#7D7D7D"/>                        <path d="M4.87075 10.8362C5.0703 10.6034 5.43046 10.6034 5.63001 10.8362L8.70617 14.425C8.98417 14.7494 8.75372 15.2504 8.32654 15.2504H2.17422C1.74704 15.2504 1.51659 14.7494 1.79459 14.425L4.87075 10.8362Z" fill="#F4F4F4" stroke="#7D7D7D"/>                        <path d="M13.4321 15.3818L12.6445 19.7133L17.3698 18.532L27.6078 7.90017L24.4577 4.75L13.4321 15.3818Z" fill="#F4F4F4"/>                        <path d="M12.9559 20.1065L16.6203 19.2858H16.651C16.8231 19.2856 16.9934 19.2515 17.1522 19.1854C17.311 19.1193 17.4551 19.0226 17.5764 18.9007L27.6128 8.8726C27.8608 8.6237 28 8.2868 28 7.9356C28 7.58439 27.8608 7.24749 27.6128 6.9986L25.3802 4.76189C25.1311 4.51411 24.7939 4.375 24.4424 4.375C24.0909 4.375 23.7538 4.51411 23.5047 4.76189L13.4623 14.7959C13.3393 14.9192 13.2427 15.0662 13.1784 15.228C13.1141 15.3898 13.0835 15.563 13.0883 15.7371L12.2633 19.415C12.2464 19.4975 12.2464 19.5825 12.2633 19.665C12.2795 19.74 12.3104 19.811 12.3543 19.8739C12.3982 19.9368 12.4542 19.9904 12.5191 20.0314C12.6125 20.0905 12.7206 20.1222 12.8312 20.123C12.8738 20.1238 12.9163 20.1191 12.9577 20.1088M24.0863 5.3435C24.1808 5.24954 24.3087 5.19679 24.442 5.19679C24.5753 5.19679 24.7032 5.24954 24.7976 5.3435L27.0307 7.57976C27.0781 7.62572 27.1157 7.68076 27.1413 7.74159C27.1669 7.80242 27.1799 7.86778 27.1797 7.93376C27.1796 8.0001 27.1664 8.06576 27.1408 8.12699C27.1152 8.18821 27.0778 8.24378 27.0307 8.29052L26.0631 9.25729L23.116 6.31256L24.0863 5.3435ZM14.3139 15.1078L22.5339 6.89281L25.481 9.83753L17.2611 18.0525L14.3139 15.1078ZM13.5173 17.5973L13.9056 15.8635L16.5126 18.4684L14.6481 18.8842L13.5173 17.5973Z" fill="#7D7D7D"/>                        <path d="M16.7549 16.0217C16.701 16.022 16.6475 16.0115 16.5977 15.9907C16.548 15.9699 16.5029 15.9394 16.4652 15.9008C16.3882 15.8236 16.345 15.719 16.345 15.61C16.345 15.501 16.3882 15.3965 16.4652 15.3192L22.7225 9.06751C22.7605 9.02882 22.8057 8.99809 22.8557 8.9771C22.9057 8.95612 22.9594 8.94531 23.0136 8.94531C23.0678 8.94531 23.1214 8.95612 23.1714 8.9771C23.2214 8.99809 23.2667 9.02882 23.3046 9.06751C23.3816 9.14476 23.4248 9.24932 23.4248 9.35832C23.4248 9.46732 23.3816 9.57188 23.3046 9.64913L17.0473 15.9008C17.0091 15.9394 16.9635 15.97 16.9133 15.9907C16.8631 16.0115 16.8092 16.022 16.7549 16.0217Z" fill="#7D7D7D"/>                    </svg>
                        </button>
                    </div>
                </div>
                <div class="input-wrapper" v-else>
                    <div
                        v-for="(answer, answerIndex) in item.answers"
                        :key="answer.text+'-'+answerIndex"
                    >
                        <input
                            v-if="editingComments.includes(answerIndex)"
                            v-model="answer.comment"
                            :ref="'comment-2-'+answerIndex"
                            v-click-outside-2="clickOutsideComments"
                            class="training--content--topic--edit task--comment--input"
                            type="text"
                            :placeholder="`${toLocal('training_edit.comment_for_answer')} „${answer.text ? answer.text : String.fromCharCode(65 + answerIndex)}“`"
                        >
                        <div 
                            v-else 
                            @click="editingComments.push(answerIndex); $nextTick(() => $refs['comment-2-'+answerIndex][0].focus())" 
                            class="task--comment--input comment--text" 
                            v-html="convertToHyperlinks(answer.comment && answer.comment.length > 0 ? answer.comment : `${toLocal('training_edit.comment_for_answer')} „${answer.text ? answer.text : String.fromCharCode(65 + answerIndex)}“`)"
                        >
                        </div>
                        <button @click="editComment(answer,answerIndex)">
                            <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">                        <rect x="0.5" y="0.5" width="20.0015" height="14.7511" rx="1.5" fill="#F4F4F4" stroke="#7D7D7D"/>                        <circle cx="5.25061" cy="5.25013" r="1.25013" fill="#F4F4F4" stroke="#7D7D7D"/>                        <path d="M11.867 6.49196C12.0669 6.25208 12.4353 6.25208 12.6352 6.49196L19.2508 14.4307C19.5222 14.7563 19.2906 15.2508 18.8667 15.2508H5.63553C5.21161 15.2508 4.98003 14.7563 5.25142 14.4307L11.867 6.49196Z" fill="#F4F4F4" stroke="#7D7D7D"/>                        <path d="M4.87075 10.8362C5.0703 10.6034 5.43046 10.6034 5.63001 10.8362L8.70617 14.425C8.98417 14.7494 8.75372 15.2504 8.32654 15.2504H2.17422C1.74704 15.2504 1.51659 14.7494 1.79459 14.425L4.87075 10.8362Z" fill="#F4F4F4" stroke="#7D7D7D"/>                        <path d="M13.4321 15.3818L12.6445 19.7133L17.3698 18.532L27.6078 7.90017L24.4577 4.75L13.4321 15.3818Z" fill="#F4F4F4"/>                        <path d="M12.9559 20.1065L16.6203 19.2858H16.651C16.8231 19.2856 16.9934 19.2515 17.1522 19.1854C17.311 19.1193 17.4551 19.0226 17.5764 18.9007L27.6128 8.8726C27.8608 8.6237 28 8.2868 28 7.9356C28 7.58439 27.8608 7.24749 27.6128 6.9986L25.3802 4.76189C25.1311 4.51411 24.7939 4.375 24.4424 4.375C24.0909 4.375 23.7538 4.51411 23.5047 4.76189L13.4623 14.7959C13.3393 14.9192 13.2427 15.0662 13.1784 15.228C13.1141 15.3898 13.0835 15.563 13.0883 15.7371L12.2633 19.415C12.2464 19.4975 12.2464 19.5825 12.2633 19.665C12.2795 19.74 12.3104 19.811 12.3543 19.8739C12.3982 19.9368 12.4542 19.9904 12.5191 20.0314C12.6125 20.0905 12.7206 20.1222 12.8312 20.123C12.8738 20.1238 12.9163 20.1191 12.9577 20.1088M24.0863 5.3435C24.1808 5.24954 24.3087 5.19679 24.442 5.19679C24.5753 5.19679 24.7032 5.24954 24.7976 5.3435L27.0307 7.57976C27.0781 7.62572 27.1157 7.68076 27.1413 7.74159C27.1669 7.80242 27.1799 7.86778 27.1797 7.93376C27.1796 8.0001 27.1664 8.06576 27.1408 8.12699C27.1152 8.18821 27.0778 8.24378 27.0307 8.29052L26.0631 9.25729L23.116 6.31256L24.0863 5.3435ZM14.3139 15.1078L22.5339 6.89281L25.481 9.83753L17.2611 18.0525L14.3139 15.1078ZM13.5173 17.5973L13.9056 15.8635L16.5126 18.4684L14.6481 18.8842L13.5173 17.5973Z" fill="#7D7D7D"/>                        <path d="M16.7549 16.0217C16.701 16.022 16.6475 16.0115 16.5977 15.9907C16.548 15.9699 16.5029 15.9394 16.4652 15.9008C16.3882 15.8236 16.345 15.719 16.345 15.61C16.345 15.501 16.3882 15.3965 16.4652 15.3192L22.7225 9.06751C22.7605 9.02882 22.8057 8.99809 22.8557 8.9771C22.9057 8.95612 22.9594 8.94531 23.0136 8.94531C23.0678 8.94531 23.1214 8.95612 23.1714 8.9771C23.2214 8.99809 23.2667 9.02882 23.3046 9.06751C23.3816 9.14476 23.4248 9.24932 23.4248 9.35832C23.4248 9.46732 23.3816 9.57188 23.3046 9.64913L17.0473 15.9008C17.0091 15.9394 16.9635 15.97 16.9133 15.9907C16.8631 16.0115 16.8092 16.022 16.7549 16.0217Z" fill="#7D7D7D"/>                    </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <portal to="training-test-task">
            <SimpleModal v-if="editingAnswer && editingAnswer.open" @onClose="editingAnswer.open = false">
                <template v-slot:modalContent>
                   <div class="content-test-task">
                        <div class="row">
                            <div class="col">
                                <div 
                                class="image-container"
                                >   
                                    <div class="upload-progress" v-if="isUploadingFile">
                                        <span class="progress-bar"><span :style="{width: fileUploadedProgress+'%'}"></span> </span>
                                    </div>
                                    <div class="image-wrapper">
                                        <div class="image">
                                            <img :src="getFileUrl(getItemImage(editingAnswer))" alt="">
                                            <TrainingTaskCorrectSvg v-if="item.comment_tab == 1 && !item.comment_correct_file && editingAnswer.item.value == 'comment_correct'" class="training-svg-centered default-icon" />
                                            <TrainingTaskIncorrectSvg v-else-if="item.comment_tab == 1 && !item.comment_incorrect_file && editingAnswer.item.value == 'comment_incorrect' " class="training-svg-centered default-icon" />
                                            <svg class="default-icon" v-else-if="[0, 2].includes(item.comment_tab) && (item.comment_tab == 0 ? !item.comment_main_file : !item.answers[editingAnswer.index].file)" width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="50" cy="50" r="50" fill="#B2B2B2"/>
                                                <path d="M30 47.6352L47.1905 67L57.3175 54.3446L76 31" stroke="white" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                        <h4>{{ editingAnswer.item.value == 'comment_correct' ? toLocal("training.task_correct") : editingAnswer.item.value == 'comment_incorrect' ? toLocal("training.task_incorrect") : toLocal('trainingEdit.answer_accepted') }}</h4>
                                    </div>
                                    <div class="input-container upload-list-container">
                                        <label class="upload-container-label">{{ toLocal('trainingEdit.upload_media') }}</label>
                                        <ItemUploadOptions
                                            class="item-upload-wrapper"
                                            :item="item"
                                            :options="{
                                                showQR: false
                                            }"
                                            :item_index="itemIndex ? itemIndex : 0"
                                            :topic_index="topicIndex ? topicIndex : 0"
                                            :trainingType="training.trainingType"
                                            @openGallery="openGallery(topic, index)"
                                            @onTrainingMediaChange="fileInput"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="text-container">
                                <input
                                    v-if="item.comment_tab != 2 && editingModalComment"
                                    class="training--content--topic--edit task--comment--input"
                                    type="text"
                                    ref="modal-comment"
                                    v-click-outside-2="clickModalComment"
                                    v-model="item[editingAnswer.item.value == 'comment_main' ? 'comment_main' : (editingAnswer.item.value == 'comment_correct' ? 'comment_correct' : 'comment_incorrect')]"
                                    :placeholder="editingAnswer.item.value == 'comment_main' ? toLocal('training.task_answer_comment') : editingAnswer.item.value == 'comment_correct' ? toLocal('test.congratulations') : toLocal('test.incorrect_picked')"
                                >
                                <input
                                    v-else-if="editingModalComment"
                                    class="training--content--topic--edit task--comment--input"
                                    type="text"
                                    ref="modal-comment"
                                    v-click-outside-2="clickModalComment"
                                    v-model="item.answers[editingAnswer.index].comment"
                                    :placeholder="toLocal('training.task_answer_comment')"
                                >
                                <div 
                                    v-else 
                                    @click="editingModalComment=true; $nextTick(() => $refs['modal-comment'].focus())" 
                                    class="task--comment--input comment--text modal--comment" 
                                    v-html="convertToHyperlinks(getModalCommentHTML(item))"
                                >
                                </div>
                            </div>
                        </div>
                   </div>
                </template>
            </SimpleModal>
        </portal>
        <portal to="training-item-gallery">
            <GallerySide
                v-if="galleryOpen"
                @returnPickedGif="galleryItemSelect"
                @closeGallery="galleryOpen = false"
            />
        </portal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import GlobalModal from "@/components/layout/modals/GlobalModal.vue";
import SimpleModal from "@/components/layout/modals/SimpleModal.vue";
import DOMPurify from 'dompurify';

import ImageEditor from '@/components/layout/trainings/ImageEditor'
import Editor from "@/components/layout/trainings/training_components/Editor.vue";
import NewImageEditor from "@/components/layout/trainings/training_components/ImageEditor/NewImageEditor.vue";
import ItemUploadOptions from '@/components/layout/trainings/training_components/trainingItem/ItemUploadOptions.vue';
import GallerySide from "@/components/layout/modals/GallerySide.vue";
import TrainingTaskCorrectSvg from "@/assets/images/icons/task-correct.svg?inline";
import TrainingTaskIncorrectSvg from "@/assets/images/icons/task-incorrect.svg?inline";
import axios from 'axios'
export default {
    name: 'TestTask',
    props: {
        training: Object,
        topic: Object,
        item: Object,
        topicIndex: Number,
        itemIndex: Number,
        type: String,
        users: Array,
    },
    components: {
        draggable,
        ImageEditor,
        Editor,
        NewImageEditor,
        SimpleModal,
        ItemUploadOptions,
        GallerySide,

        TrainingTaskCorrectSvg,
        TrainingTaskIncorrectSvg
    },
    data() {
        return {
            currentlyEditingAnswer: -1,
            openStats: false,
            isEditing: false,
            partIndex: -1,
            disableItemDrag2: false,
            fileUploadedData: 0,
            fileUploadedProgress: 0,
            axiosUploadController: null,
            galleryOpen: false,
            editingComments: [],
            editingModalComment: false,
            tabs: [
                {
                    id: 0, label: 'training_edit.comment_tab_1', inputs: [{ placeholder: 'training_edit.comment_tab_1', value: 'comment_main', editing: false }]
                },
                {
                    id: 1, label:'training_edit.comment_tab_2', inputs: [{ placeholder: 'training_edit.comment_correct', value: 'comment_correct', editing: false },{ placeholder: 'training_edit.comment_incorrect', value: 'comment_incorrect', editing: false }]
                },
                {
                    id: 2, label:'training_edit.comment_tab_3'
                },
            ],
            media: [
                {
                    label: 'training_edit.upload_options.mobile',
                    icon: 'phone'
                },
                {
                    label: 'training_edit.upload_from_pc',
                    icon: 'pc'
                },
                {
                    label: 'training_edit.upload_from_gallery',
                    icon: 'gallery'
                }
            ],
            editingAnswer: null,
            isUploadingFile: false,
        }
    },
    methods:{
        editField(){
            if(this.item.taskType != 3){
                this.item.editing = 1;
                setTimeout(() => {
                    this.isEditing = true;
                }, 100);
            }
            else{
                if(this.currentlyEditingAnswer != -1){
                    var value = Array.isArray(this.$refs[`taskAnswer-${this.currentlyEditingAnswer}-${this.partIndex}`]) ? this.$refs[`taskAnswer-${this.currentlyEditingAnswer}-${this.partIndex}`][0].value : this.$refs[`taskAnswer-${this.currentlyEditingAnswer}-${this.partIndex}`].value;
                    this.setTaskAnswer(this.topicIndex, this.itemIndex, this.currentlyEditingAnswer, this.partIndex, value);
                    this.currentlyEditingAnswer = -1
                    this.partIndex = -1;
                }
                else{
                    this.item.editing = 1;
                    setTimeout(() => {
                        this.isEditing = true;
                    }, 100);
                }
                
            }
        },
        clickOutsideComments(editComment) {
            this.editingComments = []  
        },
        getModalCommentHTML(item) {
            if (!this.editingAnswer) return '';
            if (item.comment_tab != 2) {
                if (this.editingAnswer.item.value == 'comment_main') {
                    if(item['comment_main'] && item['comment_main'].length > 0)
                        return item['comment_main'];
                    else {
                        return this.toLocal('training.task_answer_comment')
                    }
                }
                else if (this.editingAnswer.item.value == 'comment_correct') {
                    if(item['comment_correct'] && item['comment_correct'].length > 0)
                        return item['comment_correct'];
                    else {
                        return this.toLocal('test.congratulations')
                    }
                }
                else {
                    if(item['comment_incorrect'] && item['comment_incorrect'].length > 0)
                        return item['comment_incorrect'];
                    else {
                        return this.toLocal('test.incorrect_picked')
                    }
                   
                }
            }
            else {
                if(item.answers[this.editingAnswer.index].comment && item.answers[this.editingAnswer.index].comment.length > 0)
                    return item.answers[this.editingAnswer.index].comment;
                else{
                    return this.toLocal('training.task_answer_comment')
                }
            }
   
        },
        clickModalComment(e) {
            this.editingModalComment = false
        },
        editComment(input, index) {
            this.editingAnswer = {
                open: true,
                item: input,
                index: index
            }
        },
        answerClick(answer) {
            this.$set(answer, 'correct', !answer.correct)
            let correct_answers = this.item.answers.filter(el => el.correct == true);
            if (correct_answers.length == 0) {
                this.$set(answer, 'voting', true)
                if(this.item.comment_tab == 1){
                    this.$set(this.item, 'comment_tab', 0)
                }
            }
            else{
                this.$set(answer, 'voting', false)
            }
        },
        getItemImage(editingItem) {
            if (this.item.comment_tab == 0) {
             return this.item.comment_main_file
            }
            else if (this.item.comment_tab == 1) {
                if (editingItem.item.value == 'comment_correct') {
                    return this.item.comment_correct_file
                }
                else if (editingItem.item.value == 'comment_incorrect') {
                    return this.item.comment_incorrect_file
                }
            }
            else {
                return editingItem.item.file
            }
        },
        openGallery() {
            this.galleryOpen = true
        },
        galleryItemSelect(item){
            // this.editingAnswer.item
            if (this.editingAnswer.item.value == 'comment_main') {
                this.$set(this.item, 'comment_main_file', item)
            }
            else if (this.editingAnswer.item.value == 'comment_correct') {
                this.$set(this.item, 'comment_correct_file', item)
            }
            else if (this.editingAnswer.item.value == 'comment_incorrect') {
                this.$set(this.item, 'comment_incorrect_file', item)
            }
            else if (this.editingAnswer.item.text) {
                this.$set(this.item.answers[this.editingAnswer.index], 'file', item)
            }
            this.galleryOpen = false;
        },
        clickOutsideAnswerTitle(e){
            if(!e.target.classList.contains('task--answer--text')){
                this.setTaskAnswer(this.topicIndex, this.itemIndex, this.currentlyEditingAnswer, this.partIndex, this.$refs[`taskAnswer-${this.currentlyEditingAnswer}`][0].value);
                 this.currentlyEditingAnswer = -1;
            }
        },
        onTrainingMediaChange(image, topicIndex, itemIndex, length) {
           
            this.$emit('onTrainingMediaChange', image, topicIndex, itemIndex, length);
        },
        getFileType (file) {
            if (file.type.match('image.*'))
                return 'image';
            if (file.type.match('video.*'))
                return 'video';
            if (file.type.match('audio.*'))
                return 'audio';
            return 'other';
        },
         fileInput(e){
            let file;
            if(e.size){
                file = e;
            }
            else{
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                file = files[0];
            }
            if(this.getFileType(file) != 'image'){
                this.$store.state.infoMessage.setMessage('error', this.toLocal('error.not_a_photo'));
                return;
            }
            let formData = new FormData();
            formData.append('file', file);
            let vm = this;
             vm.uploadFile(formData).then((response) => {
                 //response.data.file
                let file_path = response.data.file
                 if (vm.item.comment_tab == 0) {
                    vm.$set(vm.item, 'comment_main_file', file_path);
                 }
                 else if (vm.item.comment_tab == 1) {
                     if (vm.editingAnswer.item.value == 'comment_correct') {
                         vm.$set(vm.item, 'comment_correct_file', file_path);
                     }
                     else if (vm.editingAnswer.item.value == 'comment_incorrect') {
                         vm.$set(vm.item, 'comment_incorrect_file', file_path);
                     }
                 }
                else if(vm.item.comment_tab == 2){
                    vm.$set(vm.item.answers[vm.editingAnswer.index], 'file', file_path);
                }
                vm.isUploadingFile = false;
            }).catch((err)=>{
                vm.isUploadingFile = false;
            })
        },
        uploadFile(formData) {
            this.fileUploadedProgress = 0;
            this.isUploadingFile=true;
            this.axiosUploadController = new AbortController();
            return axios.post(
                `${this.$store.state.api_link}/upload-file`,
                formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onUploadProgress: progressEvent => {
                    this.fileUploadedData = progressEvent.loaded
                    this.fileUploadedProgress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                },
                signal: this.axiosUploadController.signal
                }
            );
        },
        saveMetadata($event, item, answerIndex){
            this.$emit('saveMetadata', $event, item, answerIndex);
        },
        openImageSelectInput(length){
            if(Array.isArray(this.$refs[`itemFile-${length}`])){
                this.$refs[`itemFile-${length}`][0].click();
            }
            else this.$refs[`itemFile-${length}`].click();
        },
        addTaskAnswer(topicIndex, itemIndex) {
          if(this.item.answers.length >= 26)
            return;
          if(this.item.taskType == 1)
            this.item.answers.push({text: this.toLocal('training_edit.answer_empty'), correct: false, id:this.item.answers.length})
            
          if(this.item.taskType == 3)
            this.item.answers.push({part1: this.toLocal('generic.question'), part2: this.toLocal('generic.answer')})
          this.$parent.$parent.saveSubItemAction = [this.type, topicIndex, itemIndex, 'answers', this.item.answers.length-1, 1];
          this.$set(this.item, 'votes', []);
        },
        deleteTaskAnswer(topicIndex, itemIndex, answerIndex) {
          this.item.answers.splice(answerIndex, 1);
          this.$parent.saveSubItemAction = [this.type, topicIndex, itemIndex, 'answers', answerIndex, -1];
          this.$set(this.item, 'votes', []);
        },
        editTaskAnswer(answerIndex, partIndex) {
          if(this.currentlyEditingAnswer == answerIndex && this.partIndex == partIndex)
            return;
            setTimeout(() => {
            this.currentlyEditingAnswer = answerIndex;
            this.partIndex = partIndex;

            setTimeout(() => {
              let title = this.item.answers[answerIndex].text;
              if(partIndex == 0) {
                title = this.item.answers[answerIndex].part1;
              }else if(partIndex == 1) {
                title = this.item.answers[answerIndex].part2;
              }
              if(partIndex >= 0) {
                  if(Array.isArray(this.$refs[`taskAnswer-${answerIndex}-${partIndex}`])){
                    this.$refs[`taskAnswer-${answerIndex}-${partIndex}`][0].value = title;
                    this.$refs[`taskAnswer-${answerIndex}-${partIndex}`][0].focus();
                    this.$refs[`taskAnswer-${answerIndex}-${partIndex}`][0].select();
                  }
                  else{
                    this.$refs[`taskAnswer-${answerIndex}-${partIndex}`].value = title;
                    this.$refs[`taskAnswer-${answerIndex}-${partIndex}`].focus();
                    this.$refs[`taskAnswer-${answerIndex}-${partIndex}`].select();
                  }

              } else {
                this.$refs[`taskAnswer-${answerIndex}`][0].value = title;
                this.$refs[`taskAnswer-${answerIndex}`][0].focus();
                this.$refs[`taskAnswer-${answerIndex}`][0].select();
              }
            }, 10);
          }, 10);
        },
        setTaskAnswer(topicIndex, itemIndex, answerIndex, partIndex, topicTitle) {
            if(topicTitle == "")
                topicTitle = "-";
            if(partIndex == 0) {
                this.item.answers[answerIndex].part1 = topicTitle;
            }else if(partIndex == 1) {
                this.item.answers[answerIndex].part2 = topicTitle;
            } else {
                this.item.answers[answerIndex].text = topicTitle;
            }
            this.currentlyEditingAnswer = -1;
        },
        checkVotingState(item){
          this.$set(item, 'voting', item.answers.filter(el=> el.correct == true).length == 0 ? true : false);
          return item.voting;
        },
        getHalfPosition (topicIndex, itemIndex) {
            if(this.item.half){
                let halves = 0;
                for (let i = 0; i < this.content[topicIndex].items.length; i++) {
                if(i == itemIndex){
                    return halves % 2 == 0 ? "left" : "right";
                }
                const item = this.content[topicIndex].items[i];
                if(item.half){
                    halves++;
                }
                }
            }
            return false;
        },
        isLeftHalf(topicIndex, itemIndex) {
            return this.getHalfPosition(topicIndex, itemIndex) == "left";
        },
        
        closeEditor(e){
            console.log(e);
            if(this.isEditing) {
                this.item.editing = 0;
                this.isEditing = false;
            }
        },
        setTaskCommentTab(topicIndex, itemIndex, tabIndex) {
          this.$set(this.item, 'comment_tab', tabIndex);
        },
        showTaskCommentTab3(topicIndex, itemIndex) {
          if(this.item.taskType == 3)
            return false;
          if(!this.item.answers || !this.item.answers.length)
            return true;
          let correctAnswerCount = 0;
          for (let answerIndex = 0; answerIndex < this.item.answers.length; answerIndex++) {
            const answer = this.item.answers[answerIndex];
            if(answer.correct)
              correctAnswerCount++;
            if(correctAnswerCount >= 2){
              if(this.item.comment_tab == 2)
                this.setTaskCommentTab(topicIndex, itemIndex, 1);
              return false;
            }
          }
          return true;
        },
        convertToHyperlinks(input) {
            // Sanitize the input
            let sanitizedInput = DOMPurify.sanitize(input);

            // Convert URLs to hyperlinks
            const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
            sanitizedInput = sanitizedInput.replace(urlPattern, function(url) {
                return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
            });
            const cleanInput = DOMPurify.sanitize(sanitizedInput, {
                ALLOWED_TAGS: ['a'],
                ALLOWED_ATTR: ['href', 'target', 'rel']
            });

            return cleanInput;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/_trainingEdit.scss";
.content--item--task .editor--content{
    &.editing{
        margin-top: 35px;
    }
}
.ghost {
  opacity: 0.5;
  background: #ffffff;
}
.upload-container-label{
        white-space: nowrap;
    }
.upload-progress{
    display: flex;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    
    .progress-bar{
        display: flex;
        position: relative;
        width: 100%;
        height: 25px;
        border-bottom: 2px solid #e8e8e8;
        border-radius: 8px 8px 0 0;
        overflow: hidden;
        text-align: center;
        align-items: center;
        justify-content: center;
   
        span{
            background-color: #464646;
            position: absolute;
            left: 0;
            top: 0;
            max-width: 100%;
            height: 100%;
            transition: width 0.3s ease-in-out;
        }
    }
    &.small{
        .progress-bar{
            height: 1.5rem;
        }
    }
}
.comment-wrapper{

}
.input-wrapper{
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    div{
        display: flex;
        align-items: center;
        gap: 20px;
        width: 100%;
        background-color: #F4F4F4;
        border-radius: 20px;
        margin: 5px 0;
        input{
            margin: 5px 0;
            background-color: none;
        }
    }
    button{
        display: flex;
        align-items: center;
        padding: 8px 10px;
        cursor: pointer;
        background: none;
        border: none;
        &:hover{
            svg{
                path, circle, rect{
                    stroke: #000;
                }
            }
        }
    }
}
.image-container{
    display: flex;
    flex-direction: column;
    position: relative;
    width: 400px;
    height: 400px;
    margin: auto;
    border-radius: 8px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    box-shadow: 0 0 8px 0 #00000036;
    .input-container{
        position: absolute;
        left: calc(100% + 26px);
    }
    .image-wrapper{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
    h4{
        margin: 0;
        margin-top: 12px;
    }
    .image{
        max-width: 100%;
        max-height: 85%;
        img{
            max-height: 100%;
            max-width: 100%;
        }
    }
}
.content-test-task{
    padding: 32px;
    .text-container{
        width: clamp(400px,48.75vw,936px);
        margin-top: clamp(20px, 4.44vh, 48px);
        input{
            border: 2px solid #7D7D7D;
            border-radius: 12px;
            padding: 20px;
            font-size: clamp(18px, 2.2vh, 24px);
        }
    }
    
}
.default-icon{
    margin: auto;
}
.content--item--task .task--comments{
    .task--comment--input{
        &.comment--text{
            display: inline-block;
        }
    }
}
.modal--comment{
    border: 2px solid #7D7D7D;
  border-radius: 12px;
  padding: 20px;
  font-size: clamp(18px, 2.2vh, 24px);
  width: 100%;
  text-align: left;
}
</style>
<style lang="scss">
.flip-list-move {
  transition: transform 0.5s;
}
.upload-list-container{
    label{
        font-weight: 600;
        font-size: clamp(12px, 1.2vh, 14px);
    }
    .item-upload-wrapper{
        .media-editing{
            width: fit-content;
            flex-direction: column;
            .media{
                img{
                    border: 1px solid #CACACA;
                }
            }
        }
    }
}
.task--comment--input{
    a{
        text-decoration: underline;
        color:#4c4cd0;
    }
    &.comment--text{
        display: inline-block;
    }
}
</style>